/* CustomTone 2 — User Guide behavior.
   1) Analytics beacon: reports a page_view (and per-section views) to the
      existing /api/page-track endpoint, so the admin panel can show who's
      reading the guide, from where, and when.
   2) Scroll-spy: highlights the current section in the sidebar.
   3) Mobile: nav toggle.
   Self-contained; no dependencies. */
(function () {
  'use strict';

  var ENDPOINT = 'https://customtone-auth-production.up.railway.app/api/page-track';

  // Stable-ish anonymous session id for the visit (not a login; just to
  // dedupe a single reader's section views). Stored per browser.
  function sessionId() {
    try {
      var k = 'ct2_guide_sid', v = localStorage.getItem(k);
      if (!v) { v = 's_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); localStorage.setItem(k, v); }
      return v;
    } catch (e) { return 's_' + Math.random().toString(36).slice(2, 10); }
  }
  var SID = sessionId();

  function track(event, page, payload) {
    try {
      var body = JSON.stringify({ event: event, page: page, session: SID, payload: payload || {} });
      // sendBeacon survives navigation; fall back to fetch.
      if (navigator.sendBeacon) {
        navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'application/json' }));
      } else {
        fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true });
      }
    } catch (e) { /* analytics is best-effort, never block the page */ }
  }

  function init() {
    // 1) Page view for the guide as a whole.
    track('page_view', 'guide', { ref: document.referrer || '', ua: navigator.userAgent.slice(0, 160) });

    var sections = [].slice.call(document.querySelectorAll('.ug-section[id]'));
    var navLinks = {};
    [].slice.call(document.querySelectorAll('.ug-nav a[href^="#"]')).forEach(function (a) {
      navLinks[a.getAttribute('href').slice(1)] = a;
    });

    // 2) Scroll-spy + per-section view (fires once per section per visit).
    var seen = {};
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var id = e.target.id;
          if (e.isIntersecting) {
            Object.keys(navLinks).forEach(function (k) { navLinks[k].classList.toggle('is-active', k === id); });
            if (!seen[id]) { seen[id] = 1; track('guide_section', 'guide/' + id); }
          }
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      sections.forEach(function (s) { io.observe(s); });
    }

    // 3) Mobile nav toggle.
    var btn = document.querySelector('.ug-menu-btn');
    var nav = document.querySelector('.ug-nav');
    if (btn && nav) {
      btn.addEventListener('click', function () { nav.classList.toggle('is-open'); });
      nav.addEventListener('click', function (e) { if (e.target.tagName === 'A') nav.classList.remove('is-open'); });
    }

    // Smooth-scroll for in-page links.
    [].slice.call(document.querySelectorAll('.ug-nav a[href^="#"]')).forEach(function (a) {
      a.addEventListener('click', function (ev) {
        var t = document.getElementById(a.getAttribute('href').slice(1));
        if (t) { ev.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); history.replaceState(null, '', a.getAttribute('href')); }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
